import React, { memo, useCallback } from 'react';
import { motion } from 'framer-motion';
import { MOOD_LEVELS } from '../hooks/useMoodTracking';
import { haptic } from '../../../shared/utils/haptics';
import { cn } from '../../../shared/utils/cn';

/**
 * MoodIndicator - Compact mood display for header
 */
export const MoodIndicator = memo(function MoodIndicator({ mood, energy, onClick }) {
  const handleClick = useCallback(() => {
    haptic.tap();
    onClick?.();
  }, [onClick]);

  if (!mood) return null;

  const moodData = MOOD_LEVELS[mood];

  return (
    <motion.button
      onClick={handleClick}
      className={cn(
        'flex items-center gap-1.5 px-2 py-1.5',
        'glass-interactive'
      )}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <span className="text-lg">{moodData?.emoji}</span>
      {energy && (
        <div className="flex gap-0.5">
          {[1, 2, 3, 4].map(bar => (
            <div
              key={bar}
              className={cn(
                'w-0.5 rounded-full',
                bar <= energy ? 'bg-zinc-400' : 'bg-zinc-700'
              )}
              style={{ height: `${4 + bar}px` }}
            />
          ))}
        </div>
      )}
    </motion.button>
  );
});

export default MoodIndicator;
